module.exports = __webpack_public_path__ + "resource/img/required_form.1f241fd5.svg";